var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatPostcard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 40,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.8889,
    height: 40,
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6672_16131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7695 15.3713C14.7695 14.3655 15.5849 13.5502 16.5907 13.5502H31.5818L34.2211 15.8012V25.4465C34.2211 25.9988 33.7734 26.4465 33.2211 26.4465H15.7695C15.2172 26.4465 14.7695 25.9988 14.7695 25.4465V15.3713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7694 14.5693C14.7694 14.0171 15.2171 13.5693 15.7694 13.5693L32.0827 13.5693L34.2212 15.7183V24.0307H14.7694V14.5693Z",
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4844 22.5404C16.4844 22.2643 16.7082 22.0404 16.9844 22.0404H31.5841C31.8603 22.0404 32.0841 22.2643 32.0841 22.5404V25.0964C32.0841 25.3726 31.8603 25.5964 31.5841 25.5964H16.9844C16.7082 25.5964 16.4844 25.3726 16.4844 25.0964V22.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1367 22.9938V23.5401H18.683V22.9938H18.1367ZM17.9181 22.9801C17.9181 22.867 18.0099 22.7753 18.123 22.7753H18.6967C18.8098 22.7753 18.9016 22.867 18.9016 22.9801V23.5538C18.9016 23.6669 18.8098 23.7586 18.6967 23.7586H18.123C18.0099 23.7586 17.9181 23.6669 17.9181 23.5538V22.9801ZM18.1365 24.1956V24.7419H18.6829V24.1956H18.1365ZM17.918 24.1819C17.918 24.0688 18.0097 23.9771 18.1229 23.9771H18.6965C18.8097 23.9771 18.9014 24.0688 18.9014 24.1819V24.7556C18.9014 24.8687 18.8097 24.9604 18.6965 24.9604H18.1229C18.0097 24.9604 17.918 24.8687 17.918 24.7556V24.1819ZM19.3386 23.5403V22.9939H19.8849V23.5403H19.3386ZM19.3249 22.7754C19.2117 22.7754 19.12 22.8671 19.12 22.9803V23.5539C19.12 23.6671 19.2117 23.7588 19.3249 23.7588H19.8986C20.0117 23.7588 20.1034 23.6671 20.1034 23.5539V22.9803C20.1034 22.8671 20.0117 22.7754 19.8986 22.7754H19.3249ZM19.2293 23.9771C19.2896 23.9771 19.3386 24.026 19.3386 24.0863V24.4141C19.3386 24.4745 19.2896 24.5234 19.2293 24.5234C19.1689 24.5234 19.12 24.4745 19.12 24.4141V24.0863C19.12 24.026 19.1689 23.9771 19.2293 23.9771ZM19.7756 24.0863C19.7756 24.026 19.7267 23.9771 19.6664 23.9771C19.606 23.9771 19.5571 24.026 19.5571 24.0863V24.7419H19.2293C19.1689 24.7419 19.12 24.7908 19.12 24.8512C19.12 24.9115 19.1689 24.9604 19.2293 24.9604H19.6664C19.7267 24.9604 19.7756 24.9115 19.7756 24.8512V24.4148H19.9942C20.0546 24.4148 20.1035 24.3659 20.1035 24.3055C20.1035 24.2452 20.0546 24.1963 19.9942 24.1963H19.7756V24.0863ZM20.1032 24.6333C20.1032 24.573 20.0543 24.5241 19.9939 24.5241C19.9336 24.5241 19.8847 24.573 19.8847 24.6333V24.8519C19.8847 24.9122 19.9336 24.9611 19.9939 24.9611C20.0543 24.9611 20.1032 24.9122 20.1032 24.8519V24.6333Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6465 16.244C16.6465 15.9679 16.8703 15.744 17.1465 15.744H20.6895C20.9656 15.744 21.1895 15.9679 21.1895 16.244V20.0852H17.5571C17.0542 20.0852 16.6465 19.6775 16.6465 19.1747V16.244Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.9187,
    cy: 17.4399,
    rx: 1.12967,
    ry: 1.14022,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6465 18.5328L21.0014 19.8328C21.113 19.8661 21.1895 19.9688 21.1895 20.0853H16.6465V18.5328Z",
    fill: "#AEAFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1895 18.0513L16.6464 20.0692C16.6464 20.2984 16.8323 20.4842 17.0615 20.4842H20.6895C20.9656 20.4842 21.1895 20.2604 21.1895 19.9842V18.0513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.3262,
    y: 16.3754,
    width: 8.75661,
    height: 1.01263,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.3262,
    y: 18.0435,
    width: 6.45749,
    height: 0.398628,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.3262,
    y: 19.1102,
    width: 7.47173,
    height: 0.398628,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.3262,
    y: 20.0862,
    width: 6.79567,
    height: 0.39863,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5996,
    y: 22.9897,
    width: 9.18462,
    height: 0.398628,
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5996,
    y: 23.8682,
    width: 8.35358,
    height: 0.39863,
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5996,
    y: 24.7612,
    width: 9.52156,
    height: 0.39863,
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.084 13.5692L34.2211 15.7543H32.584C32.3078 15.7543 32.084 15.5304 32.084 15.2543V13.5692Z",
    fill: "#4F5B94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6672_16131",
    x: 12.9484,
    y: 12.6396,
    width: 23.0935,
    height: 16.5387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.910573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.910573
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0588235 0 0 0 0 0.14902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6672_16131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6672_16131",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatPostcard);
export default __webpack_public_path__ + "static/media/format-postcard.f92d4230891b494bf6fcb78778f3abbd.svg";
export { ForwardRef as ReactComponent };